import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class AircraftModelsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      name: '',
      model: '',
      motor: '',
      size: '',
      class: '',
      pilots_type: '',
      use_in_planning: false,
      ground_consumption: '',
      flight_consumption: '',
      fuel_capacity: '',
      fuel_type_id: '',
      fuel_unity_id: '',
      manufacturer: '',
      cost_center: '',
      fuel_types_list: [],
      fuel_unity_list: [],
      similar_models: [],
      similar_models_list: [],
      aircraft_model_related_id: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addAircraftSimilar = this.addAircraftSimilar.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/modelo/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/aeronave/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            model: responseJson.data.model,
            class: responseJson.data.class,
            size: responseJson.data.size,
            motor: responseJson.data.motor,
            use_in_planning: responseJson.data.use_in_planning,
            fuel_type_id: responseJson.data.fuel_type_id,
            fuel_unity_id: responseJson.data.fuel_unity_id,
            manufacturer: responseJson.data.manufacturer,
            cost_center: responseJson.data.cost_center,
            pilots_type: responseJson.data.pilots_type,
            flight_consumption: responseJson.data.flight_consumption,
            ground_consumption: responseJson.data.ground_consumption,
            fuel_capacity: responseJson.data.fuel_capacity,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/tipo/combustivel/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ fuel_types_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/unidade/combustivel/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ fuel_unity_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/similares/lista/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({similar_models_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/similares/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({similar_models: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* Lista de tipos de combustível */}); /* Lista de unidades de combustível */}); /* Lista de modelos de aeronave */}); /* Modelos similares relacionados */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      model: this.state.model,
      motor: this.state.motor,
      size: this.state.size,
      class: this.state.class,
      use_in_planning: this.state.use_in_planning,
      fuel_type_id: this.state.fuel_type_id,
      fuel_unity_id: this.state.fuel_unity_id,
      manufacturer: this.state.manufacturer,
      cost_center: this.state.cost_center,
      pilots_type: this.state.pilots_type,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addAircraftSimilar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_model_id: this.state.id,
      aircraft_model_related_id: this.state.aircraft_model_related_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo/similar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var data_temp = self.state.similar_models;
          data_temp.push(responseJson.data);
          self.setState({similar_models: data_temp});
          self.loadData();
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var aircraft_similar_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.ModelosAeronaves.EditarModelosAeronaves.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/modelo/similar/' + aircraft_similar_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(aircraft_similar_id);
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(aircraft_similar_id) {
    var data = this.state.similar_models;
    data.map(function(dado, index){
      if (dado.id == aircraft_similar_id) {
        data.splice(index, 1);
      }
    });
    this.setState({similar_models: data});
  }
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ModelosAeronaves.EditarModelosAeronaves.titulo}</h3>
      <Link to="/aeronave/modelos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.NomeAeronave} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Modelo}:</label>
              <input type="text" name="model" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.ModeloAeronave} value={this.state.model} onChange={this.handleChange.bind(this, 'model')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Classe}:</label>
              <Select
                className="form-field-name"
                name="class"
                value={this.state.class}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneClasse}
                onChange={this.handleSelectChange.bind(this, 'class')}
                options={[
                  {value: "Avião", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesClasses.Aviao},
                  {value: "Helicóptero", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesClasses.Helicoptero},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Porte}:</label>
              <Select
                className="form-field-name"
                name="size"
                value={this.state.size}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecionePorte}
                onChange={this.handleSelectChange.bind(this, 'size')}
                options={[
                  {value: "PP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.Pequeno},
                  {value: "MP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.Medio},
                  {value: "SMP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.SuperMedio },
                  {value: "GP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.Grande},
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.UnidadeCombustivel}:</label>
              <Select
                className="form-field-name"
                name="fuel_unity_id"
                value={this.state.fuel_unity_id}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneUnidadeCombustivel}
                onChange={this.handleSelectChange.bind(this, 'fuel_unity_id')}
                options={this.state.fuel_unity_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.TipoCombustivel}:</label>
              <Select
                className="form-field-name"
                name="fuel_type_id"
                value={this.state.fuel_type_id}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneTipoCombustivel}
                onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
                options={this.state.fuel_types_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Motorizacao}:</label>
              <Select
                className="form-field-name"
                name="motor"
                value={this.state.motor}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneMotorizacao}
                onChange={this.handleSelectChange.bind(this, 'motor')}
                options={[
                  {value: "MULTI", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesMotorizacao.Multimotor},
                  {value: "MONO", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesMotorizacao.Monomotor},
                ]}
              />
            </div>
            
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.TipoTripulacao}:</label>
              <Select
                className="form-field-name"
                name="pilots_type"
                value={this.state.pilots_type}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneTripulacao}
                onChange={this.handleSelectChange.bind(this, 'pilots_type')}
                options={[
                  {value: "Dual pilot", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesTipoTripulacao.DualPilot},
                  {value: "Single pilot", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesTipoTripulacao.SinglePilot},
                ]}
              />
            </div>
            
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Fabricante}:</label>
              <input type="text" name="manufacturer" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.FabricanteAeronave} value={this.state.manufacturer} onChange={this.handleChange.bind(this, 'manufacturer')} />
            </div>
            
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.botaoSalvarEdicao}</button>
          </div>
        </div>
      </form>
      {/* Modelos similares */}
      <hr/>
      <h3>{this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.titulo}</h3>
      <hr/>
      <form onSubmit={this.addAircraftSimilar}>
        <div className="form-group">
          <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.formulario.AdicionarModelo}:</label>
          <Select
            className="form-field-name"
            name="aircraft_model_related_id"
            value={this.state.aircraft_model_related_id}
            searchable={true}
            placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.formulario.placeholder.SelecionarModeloSimilar}
            onChange={this.handleSelectChange.bind(this, 'aircraft_model_related_id')}
            options={this.state.similar_models_list}
          />
        </div>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.formulario.botaoAdicionarSimilar}</button>
      </form>
      <hr/>
      <table className="table">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              {this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.modelo}
            </th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.acoes}</th>
          </tr>
        </thead>
        <tbody id="frotas">
          {Object.keys(self.state.similar_models).map(function(k) {
            return (
              <tr key={self.state.similar_models[k].id}>
                <td>
                  {self.state.similar_models[k].id}
                </td>
                <td>
                  {self.state.similar_models[k].model}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.similar_models[k].id} onClick={self.delete}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftModelsEdit;



// WEBPACK FOOTER //
// ./src/Components/AircraftModels/AircraftModelsEdit.js